export const TEST_IDS = {
  approveButton: 'approve-button',
  rejectButton: 'reject-button',
  approvedText: 'approved-text',
  rejectedText: 'rejected-text',
}
